<template>
  <v-container fluid>
    <SearchBar v-model="search" />

    <v-card outlined class="rounded-xl mt-5">
      <ListTitle
        title="Roles"
        @new="$router.push({ path: '/employee/role/create' })"
      />

      <v-card-text>
        <v-data-table
          :headers="headers"
          :items="roles"
          :options.sync="options"
          :server-items-length="count"
          :loading="loading"
          class="table-header"
          :footer-props="{ 'items-per-page-options': rowsPerPageItems }"
        >
          <!-- Table body -->
          <template v-slot:item="{ item, index }">
            <tr>
              <td>#{{ index + 1 }}</td>
              <td>{{ item.name }}</td>

              <td class="text-right px-0">
                <v-menu bottom left offset-y>
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn icon v-bind="attrs" v-on="on">
                      <v-icon>mdi-dots-vertical</v-icon>
                    </v-btn>
                  </template>

                  <v-list class="menu-button">
                    <v-list-item @click="editRole(item)">
                      <v-list-item-title>{{
                        $t("buttons.edit")
                      }}</v-list-item-title>
                    </v-list-item>
                    <v-list-item @click="deleteRole(item)">
                      <v-list-item-title>{{
                        $t("buttons.delete")
                      }}</v-list-item-title>
                    </v-list-item>
                  </v-list>
                </v-menu>
              </td>
            </tr>
          </template>
        </v-data-table>
      </v-card-text>
    </v-card>
  </v-container>
</template>

<script>
import roleService from "../service";

export default {
  name: "role-list",
  data() {
    return {
      headers: [
        {
          text: "#",
          value: "",
          sortable: false,
          width: "5%",
        },
        { text: this.$t("labels.name"), value: "name", sortable: false },
        { text: "", value: "actions", sortable: false },
      ],
      search: "",
      roles: [],
      count: 0,
      loading: false,
      rowsPerPageItems: [10, 25, 50, 100],
      options: {
        page: 1,
        itemsPerPage: 10,
        sortBy: ["name"],
        sortDesc: [false],
      },
    };
  },

  watch: {
    search() {
      if (this.search.length > 3 || this.search.length === 0) {
        this.getList();
      }
    },
    options: {
      handler() {
        this.getList();
      },
      deep: true,
    },
  },

  created() {
    this.getList();
  },

  methods: {
    async getList() {
      this.loading = true;
      const { page, itemsPerPage, sortBy, sortDesc } = this.options;
      const offset = (page - 1) * itemsPerPage;
      const limit = itemsPerPage;
      const orderBy = [sortBy[0] || "name", sortDesc[0]];

      try {
        const response = await roleService.getAll({
          limit,
          offset,
          search: this.search,
          orderBy,
        });
        this.roles = response.data;
        this.count = response.count;
      } catch (err) {
        console.error("Error loading roles:", err);
      } finally {
        this.loading = false;
      }
    },

    editRole(role) {
      this.$router.push({ name: "employee-role-edit", params: role });
    },

    deleteRole(role) {
      this.$swal({
        title: this.$t("messages.title.areYouSure"),
        text: this.$t("messages.text.youWontBeAbleToRevert"),
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: this.$t("buttons.yes"),
        cancelButtonText: this.$t("buttons.no"),
      }).then(async (result) => {
        if (result.value) {
          try {
            this.$Progress.start();
            const response = await roleService.delete(role.id);
            if (response.data) {
              this.$swal("Deleted!", "Role has been deleted.", "success");
              this.getList();
            }
          } catch (error) {
            this.$toasted.error(error.data.message, {
              position: "top-right",
              showHideTransition: "slide",
              icon: "error",
              duration: 5000,
            });
          } finally {
            this.$Progress.finish();
          }
        }
      });
    },
  },
};
</script>